module.exports = __webpack_public_path__ + "img/partner_img18.8ad77330.png";